import {useState} from 'react';
import HeaderView from './HeaderView';

function HeaderContainer() {
  const [areDetailsShown, setAreDetailsShown] = useState(false);

  return (
    <HeaderView
      areDetailsShown={areDetailsShown}
      onSwitchDetails={() => setAreDetailsShown(current => !current)}
    />
  );
}

export default HeaderContainer;
